/** Default when API omits expiresInSeconds (matches prod JWT_EXPIRATION_IN_MINUTES default). */
const DEFAULT_ACCESS_TOKEN_TTL_SECONDS = 15 * 60;

/** Refresh this long before access token expiry to avoid 401 bursts. */
const REFRESH_BEFORE_EXPIRY_MS = 2 * 60 * 1000;

let accessTokenExpiresAtMs: number | null = null;

export function setAccessTokenLifetime(expiresInSeconds?: number | null): void {
  const ttlSeconds =
    typeof expiresInSeconds === 'number' && expiresInSeconds > 0
      ? expiresInSeconds
      : DEFAULT_ACCESS_TOKEN_TTL_SECONDS;

  accessTokenExpiresAtMs = Date.now() + ttlSeconds * 1000;
}

export function clearAccessTokenLifetime(): void {
  accessTokenExpiresAtMs = null;
}

export function getProactiveRefreshDelayMs(): number | null {
  if (accessTokenExpiresAtMs === null) {
    return null;
  }

  return Math.max(0, accessTokenExpiresAtMs - Date.now() - REFRESH_BEFORE_EXPIRY_MS);
}
